// @flow
import { get } from 'lodash';
import { resolve } from 'redux-optimist-promise';

import {
  FETCH_PROPOSALS_BY_ID,
  FETCH_PROPOSALS,
  PREPARE_BE,
  CLEAR_PROPOSALS,
} from 'Store/booking/proposals/constants';
import { UPDATE_TRIP_DATE_CRITERIA } from 'Store/constants';
import { TRIP_INFORMATION_SET_KIDS } from 'Store/trip-information/kids/constants';
import { TRIP_INFORMATION_SET_ADULTS_NUMBER } from 'Store/trip-information/adults/constants';

type State = ?Resort;

const initialState: State = null;

export function resortReducer(state: State = initialState, action: Action<*>): State {
  switch (get(action, 'type')) {
    case resolve(FETCH_PROPOSALS):
    case resolve(FETCH_PROPOSALS_BY_ID): {
      return get(action, 'payload.proposals.resort', null);
    }
    case PREPARE_BE:
      return get(action, 'payload.resort', null);

    case FETCH_PROPOSALS:
    case CLEAR_PROPOSALS:
    case TRIP_INFORMATION_SET_KIDS:
    case TRIP_INFORMATION_SET_ADULTS_NUMBER:
    case UPDATE_TRIP_DATE_CRITERIA:
      return initialState;

    default:
      return state;
  }
}
